import { render, staticRenderFns } from "./LoginIpChange.vue?vue&type=template&id=e36c4654&"
import script from "./LoginIpChange.vue?vue&type=script&lang=js&"
export * from "./LoginIpChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports